import React, {
  useState,
  useContext,
  type Dispatch,
  type SetStateAction,
  type ReactNode,
} from "react";

type ToastEntryType = { content: ReactNode; id: string; dismissed: boolean };
type ToastsContextStateType = ToastEntryType[];

export type ToastsContextProviderType = [
  ToastsContextStateType,
  Dispatch<SetStateAction<ToastsContextStateType>>,
];

export const ToastsContext = React.createContext<ToastsContextProviderType>([
  [],
  () => {
    // placeholder
  },
]);

export const useToastsContext = () => {
  const toastsContext = useContext(ToastsContext);
  const [toasts, setToasts] = toastsContext;

  const dismissToastById = (id: string) => {
    if (toasts.length === 0) return;
    setToasts((toasts) =>
      toasts.map((toast: ToastEntryType) =>
        toast.id === id ? { ...toast, dismissed: true } : toast,
      ),
    );
  };

  const dismissAllToasts = () => {
    if (toasts.length === 0) return;
    setToasts((toasts) =>
      toasts.map((toast: ToastEntryType) => ({ ...toast, dismissed: true })),
    );
  };

  const addToast = (updatedToast: ToastEntryType) => {
    const foundToast = toasts.find(
      (toast: ToastEntryType) => toast.id === updatedToast.id,
    );
    // don't like this solution, but it works for now
    if (
      JSON.stringify(foundToast?.content) ===
      JSON.stringify(updatedToast.content)
    ) {
      return;
    }

    setToasts((toasts) => {
      const foundToast = toasts.find(
        (toast: ToastEntryType) => toast.id === updatedToast.id,
      );
      // if the toast already exists, update it
      if (foundToast) {
        return toasts.map((toast: ToastEntryType) =>
          toast.id === updatedToast.id ? updatedToast : toast,
        );
      }
      // otherwise add it
      return [...toasts, updatedToast];
    });
  };
  return { toastsContext, dismissToastById, addToast, dismissAllToasts };
};

type Props = {
  children: ReactNode;
};

export const ToastsContextProvider = ({ children }: Props) => {
  const getterAndSetter = useState<ToastsContextStateType>([]);
  return (
    <ToastsContext.Provider value={getterAndSetter}>
      {children}
    </ToastsContext.Provider>
  );
};
